// extracted by mini-css-extract-plugin
export default {"termsWrapper":"styles_termsWrapper__iFDJM","logo":"styles_logo__8JSkN","logoContainer":"styles_logoContainer__+KKnM","termsContainer":"styles_termsContainer__2Klgk"};